// @ts-nocheck
// recent logs of user...
export const RECENT_LOGS_REQUEST = "RECENT_LOGS_REQUEST";
export const RECENT_LOGS_SUCCESS = "RECENT_LOGS_SUCCESS";
export const RECENT_LOGS_FAILURE = "RECENT_LOGS_FAILURE";
// recent logs of user...